import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { Translate } from 'react-localize-redux'
import useStyles from './RemovePlayerAccessStyles'

const RemovePlayerDialog = ({ open, onClose, onSubmit }) => {
  const classes = useStyles()

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Translate id="movePlayers.remove-player-from-team" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Translate id="movePlayers.are-you-sure-you-want-to-remove-this-player-from-the-team" />
        </DialogContentText>
        <List component="ul" disablePadding className={classes.orderedList}>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={
                <Typography color="textSecondary">
                  <Translate id="movePlayers.permanently-delete-all-team-related-data" />{' '}
                  &nbsp;
                  <strong>
                    <Translate id="movePlayers.remove-their-access-to-the-team" />
                  </strong>
                </Typography>
              }
              primaryTypographyProps={{ style: { fontWeight: '600' } }}
            />
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={
                <Typography color="textSecondary">
                  <Translate id="movePlayers.team-including-history-will-be-lost" />
                </Typography>
              }
              primaryTypographyProps={{ style: { fontWeight: '600' } }}
            />
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={
                <Typography color="textSecondary">
                  <Translate id="movePlayers.To-retain-history-without-access-consider-using-Archive-instead" />
                </Typography>
              }
              primaryTypographyProps={{ style: { fontWeight: '600' } }}
            />
          </ListItem>
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          <Translate id="button.cancel" />
        </Button>
        <Button
          onClick={onSubmit}
          color="primary"
          variant="contained"
          autoFocus
        >
          <Translate id="button.remove" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

RemovePlayerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default RemovePlayerDialog
